var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#social_linkedin_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.996 18H18v-6.602c0-3.23-.695-5.717-4.47-5.717-1.815 0-3.033.996-3.53 1.94h-.053V5.982h-3.58V18h3.728v-5.95c0-1.567.297-3.082 2.237-3.082 1.912 0 1.94 1.788 1.94 3.182V18h3.724zM.297 5.982h3.732V18H.297V5.982zM2.162 0A2.162 2.162 0 000 2.162c0 1.193.968 2.181 2.162 2.181 1.193 0 2.161-.988 2.161-2.181A2.163 2.163 0 002.161 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "social_linkedin_svg__clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "1em",
    height: "1em"
  })))));
}

export default SvgSocialLinkedin;